// extracted by mini-css-extract-plugin
module.exports = {"locale-selector":"LocaleSelector_locale-selector__jC9g_","localeSelector":"LocaleSelector_locale-selector__jC9g_"};